export default __webpack_public_path__ + "static/media/success.b0ce3e56.wav";